import React from "react";
import { Tooltip as TippyTooltip } from "react-tippy";
import "react-tippy/dist/tippy.css";

import "./tooltip.module.scss";

// Not possible to use "useContext" prop
// Because of insertion of empty div https://github.com/tvkhoa/react-tippy/issues/157
// Possible solution to use https://www.npmjs.com/package/@tippyjs/react
const Tooltip = ({ children, themeName = "aurora", ...props }) => {
	const { title, html } = { ...props };
	return (
		<>
			{title || html ? (
				<TippyTooltip theme={themeName} duration={150} arrow {...props}>
					{children}
				</TippyTooltip>
			) : (
				<>{children}</>
			)}
		</>
	);
};

export default Tooltip;
